







import { Component, Vue, Prop } from "vue-property-decorator";
@Component
export default class LimitDiscount extends Vue {
  @Prop({
    type: Object,
    required: true,
    default: () => {
      return {
        discount: 0,
        memberScope: "All",
        cumulativeWithOtherDiscount: false
      };
    }
  })
  value!: any;
}
